import {classNames} from "shared/lib/classNames/classNames";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import cls from "./MainPage.module.scss";
import Paragraph, {ParagraphTheme} from "shared/ui/Paragraph/Paragraph";
import ArrowLink from "shared/ui/ArrowLink/ArrowLink";
import Decor from "shared/assets/images/astroGirl.png"
import ScrollButton from "shared/ui/ScrollButton/ScrollButton";
import {ReactComponent as ArrowButton} from "shared/assets/icons/ArrowButtonsvg.svg";

const MainPage = () => {

    return (
        <div id={"mainPage"} className={cls.indexPage}>
            <section
                className={classNames("page-section", {}, [cls.indexPage__about])}
            >
                <div className={classNames("container container__main")}>
                    <div className={cls.About}>
                        <div className={cls.About__info}>
                            <Title className={cls.indexPage__title} sentences={["AI Astrology:", "Horoscope Today"]} colors={[TitleTheme.NEUTRAL, TitleTheme.PRIMARY]}/>
                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                AI Astrology: Horoscope Today, the ultimate mobile appfor daily horoscope insights and astrological guidance. Whether you're seeking advice on love, career, or personal growth, our app delivers personalized horoscopes tailored just for you.
                            </Paragraph>
                            <ArrowLink color={"#0AF"} href={"aboutPage"} className={cls.About__arrow} />
                        </div>

                        <div className={cls.About__img}>
                            <img src={Decor} alt="decoration"/>
                        </div>
                    </div>
                </div>
            </section>
        </div>
)
};

export default MainPage;